import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';

const BgComponent = ({ bgImg, children, showBack = true ,customBack = false, backAction }) => {

  const navigate = useNavigate();

  return (
    <div className={`${bgImg} bg-cover bg-center bg-no-repeat relative hidden lg:block h-full w-full`} >
        {showBack && <IconButton  onClick={() => customBack ? backAction() : navigate(-1)} sx={{
          margin: 5,
          color: '#fff',
          position: "absolute",
          zIndex: 999
        }}  >
          <ArrowBackIcon />
        </IconButton>}
        {
            children
        }
    </div>
  )
}

export default BgComponent